import React, { FC, useEffect, useState } from 'react'
import interact from 'interactjs'
import classNames from 'classnames'
import styles from './Card.module.scss';
import { CardEntity } from '../../ducks/cards/types'

interface CardProps {
  card: CardEntity
  setDisplayLabel: (direct: string) => void
  swipeCard(): void
  addModal(card: CardEntity): void
}

const Card: FC<CardProps> = ({card, setDisplayLabel, swipeCard, addModal}) => {
  const interactMaxRotation: number = 15
  const interactOutOfSightXCoordinate: number = 300
  const interactOutOfSightYCoordinate: number = 80
  const interactXThreshold: number = 10

  const [ interactPosition, setInteractPosition] = useState({ x: 0, y: 0, rotation: 0 })
  const [ isInteractAnimating, setIsInteractAnimating] = useState(true)
  const [ isInteractDragged, setIsInteractDragged] = useState(false)

  const transformString = () => {
    if (!isInteractAnimating || isInteractDragged) {
      const { x, y, rotation } = interactPosition
      return `translate3D(${x * 0.2}px, 0, 0) rotate(${rotation}deg)`
    }
    return undefined
  }

  const swipe = (direct: string) => {
    const element = document.getElementById(card.id)
    if (!element) return

    interact(element).unset()

    setTimeout(() => {
      swipeCard()
    }, 220)

    switch(direct) {
      case 'LEFT':
        setInteractPosition({
          x: -interactOutOfSightXCoordinate,
          y: interactOutOfSightYCoordinate,
          rotation: -interactMaxRotation
        })
        break
      case 'RIGHT':
        setInteractPosition({
          x: interactOutOfSightXCoordinate,
          y: interactOutOfSightYCoordinate,
          rotation: interactMaxRotation
        })
        addModal(card)
        break
    }
  }

  const cardClassNames = classNames(styles.card, { [styles.isAnimating] : isInteractAnimating })

  useEffect(() => {
    const element = document.getElementById(card.id)
    if (!element) return

    interact(element).draggable({
      onstart: () => {
        setIsInteractAnimating(false)
      },
      onmove: (event: any) => {
        setInteractPosition(interactPosition => {
          const x = interactPosition.x + event.dx
          const y = interactPosition.y + event.dy
          let rotation = interactMaxRotation * (x / interactXThreshold)

          if (rotation > interactMaxRotation) rotation = interactMaxRotation
          else if (rotation < -interactMaxRotation) rotation = -interactMaxRotation

          return { x, y, rotation }
        })
      },
      onend: () => {
        setIsInteractDragged(true)
        setIsInteractAnimating(true)
        setInteractPosition(interactPosition => {
          const { x } = interactPosition
          if (x > interactXThreshold) swipe('RIGHT')
          else if (x < -interactXThreshold) swipe('LEFT')
          return { x: 0, y: 0, rotation: 0 }
        })
      },
    })
  }, [])

  useEffect(() => {
    const { x } = interactPosition
    if (x > interactXThreshold) setDisplayLabel('RIGHT')
    else if (x < -interactXThreshold) setDisplayLabel('LEFT')

  }, [interactPosition.x])

  return (
    <div className={ cardClassNames } id={ card.id } style={{ transform: transformString() }}>
      <div className={ styles.imageContainer }>
        { card.imageURL && card.imageURL.large ? <img src={ card.imageURL.large } /> : <span className={ styles.noImage }>No Image </span> }
      </div>
      <div className={ styles.bottomContents }>
        <div className={ styles.heading }>
          { card.name }
        </div>
        <div className={ styles.detail }>
          <span className={ styles.item }>年齢<em>{card.age ? card.age : '-'}</em>歳</span>
          <span className={ styles.item }>身長<em>{card.height ? card.height : '-'}</em>cm</span>
          <span className={ styles.item }><em>{card.cup ? card.cup : '-'}</em>カップ</span>
        </div>
        <div className={ classNames(styles.detail, styles.supplement) }>
          <span className={ styles.item }>B<em>{card.bust}</em></span>
          <span className={ styles.item }>W<em>{card.waist}</em></span>
          <span className={ styles.item }>H<em>{card.hip}</em></span>
        </div>
        <div className={ styles.rankContent }>
          <span className={ styles.label }>FANZA 月間女優ランキング</span>
          <span className={ styles.content}>
            第
            <span className={ styles.unit }>
              { card.rank }
            </span>
            位
          </span>
        </div>
      </div>
    </div>
  )
}

export default Card